import apiKeyRoutes from '@/modules/api-keys/routes';
import assignmentRoutes from '@/modules/assignments/routes';
import auditRoutes from '@/modules/audit/routes';
import authenticatorsRoutes from '@/modules/authenticators/routes';
import broadcastRoutes from '@/modules/broadcasts/routes';
import categoryRoutes from '@/modules/category/routes';
import chaptersRoutes from '@/modules/chapters/routes';
import contentBlockRoutes from '@/modules/content-block/routes';
import contractRoutes from '@/modules/contract/routes';
import currenciesRoutes from '@/modules/currencies/routes';
import discountRoutes from '@/modules/discounts/routes';
import documentsRoutes from '@/modules/documents/routes';
import documentTemplatesRoutes from '@/modules/document-templates/routes';
import domainSetupRoutes from '@/modules/domain-setup/routes';
import downloadRoutes from '@/modules/download/routes';
import ecommerceRoutes from '@/modules/ecommerce/routes';
import formRoutes from '@/modules/forms/routes';
import guidesAndToursRoutes from '@/modules/guides-and-tours/routes';
import organisationRoutes from '@/modules/organisations/routes';
/**
 * Routes names are the same as in laravels definitions
 * Root components name is calculated by replacing all dots with dashes in route name
 *
 * Imports point to module definition file that uses
 * Composer.registerVuePlugins
 * Composer.registerComponents
 * to register plugins and components used within root component scope
 *
 */
type ModuleLoader = () => Promise<{
	default: () => void;
	name?: string;
}>;

type Routes = Record<string, ModuleLoader>;

const routes = {
	...authenticatorsRoutes,
	...apiKeyRoutes,
	...assignmentRoutes,
	...auditRoutes,
	...broadcastRoutes,
	...categoryRoutes,
	...chaptersRoutes,
	...contentBlockRoutes,
	...contractRoutes,
	...currenciesRoutes,
	...discountRoutes,
	...documentsRoutes,
	...documentTemplatesRoutes,
	...domainSetupRoutes,
	...downloadRoutes,
	...ecommerceRoutes,
	...formRoutes,
	...guidesAndToursRoutes,
	...organisationRoutes,
	'allocation-payment.index': () => import('@/modules/allocation-payment/index'),
	'fast-start.index': () => import('@/modules/fast-start/index'),
	'billing.index': () => import('@/modules/billing/index'),
	'test.index': () => import('@/modules/test/index'),
	'setting.organisations': () => import('@/modules/setting/organisations-index'),
} as Routes;

export { Routes, routes, ModuleLoader };
